import styled from "styled-components";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

export const Wrapper = styled.div`
	max-width: 100%;
	margin: 120px 140px 0 140px;
	display: flex;
	justify-content: center;
	align-items: center;

	.swiper-container {
		max-width: 100%;
		max-height: 100%;
	}

	.swiper-slide {
		max-width: 500px;
		max-height: 500px;
		width: 100%;
		height: 100%;
		text-align: center;
		font-size: 18px;
		background: #f4f4f4;
		display: -webkit-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		-webkit-align-items: center;
		align-items: center;
	}

	.swiper-container img {
		animation: scroll 40s linear infinite;
		max-width: 500px;
		max-height: 500px;
		display: block;
		object-fit: contain;
	}
	@keyframes scroll {
		0% {
			transform: translate(x);
		}

		100% {
			transform: translate(calc(-250px * 6));
		}
	}

	@media screen and (max-width: 780px) {
		margin: 30px 30px;
		.swiper-slide {
			max-width: 320px;
			max-height: 420px;
		}

		.swiper-container img {
			max-width: 320px;
			max-height: 420px;
		}
	}

	@media screen and (max-width: 500px) {
		margin: 30px 30px;
		padding-top: 130px;
	}
`;
